import React, { useId } from 'react';

import type { Props as ModalProps } from '../Modal';
import Modal from '../Modal';

import type { Props as DialogModalProps } from './DialogModalContent';
import DialogModalContent from './DialogModalContent';

export type Props = DialogModalProps &
  Omit<ModalProps, 'onRequestClose'> & {
    onRequestClose?: (payload?: unknown) => void;
  };

const DialogModal = (props: Props): JSX.Element => {
  const staticId = useId();
  const {
    cancelButtonText,
    children,
    headerId = staticId,
    headerText,
    onClickCancel,
    onClickSubmit,
    submitButtonText,
    submitButtonDisabled,
    hasCloseButton = true,
    ...other
  } = props;
  const contentProps = {
    cancelButtonText,
    children,
    headerId,
    headerText,
    onClickCancel,
    onClickSubmit,
    submitButtonText,
    submitButtonDisabled,
    hasCloseButton,
  };

  return (
    <Modal aria-labelledby={headerId} hasCloseButton={hasCloseButton} {...other}>
      <DialogModalContent {...contentProps} />
    </Modal>
  );
};

export default DialogModal;
